import buttons from './buttons.json';
import components from './components.json';
import dialogs from './dialogs.json';
import labels from './labels.json';
import pages from './pages.json';
import validations from './validations.json';

const translations = {
  buttons,
  components,
  dialogs,
  labels,
  pages,
  validations
};

export default translations;
